import { render, staticRenderFns } from "./priceQuotation.vue?vue&type=template&id=5fa13826"
import script from "./priceQuotation.vue?vue&type=script&lang=js"
export * from "./priceQuotation.vue?vue&type=script&lang=js"
import style0 from "./priceQuotation.vue?vue&type=style&index=0&id=5fa13826&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports